var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-answer',{attrs:{"action":_vm.submit,"disabled":_vm.$store.state.answer.submit}},[_vm._v("\n  "+_vm._s(_vm.$l[_vm.title])+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }